// extracted by mini-css-extract-plugin
export default {"container":"dcc_foresightedBuildabilityTriggerEquipment-container","price":"dcc_foresightedBuildabilityTriggerEquipment-price"};